import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import Footer from "../../../comum/components/Footer";
import TriagemStore from "../stores/TriagemStore";
import FiltrosTriagem from "../components/FiltrosTriagem";
import { Row, Col, Button, Label, Container } from "reactstrap";
import loading from "../../../../assets/images/ajax-loader.gif";
import { SetaSubirDupla } from '../../../comum/components/Icones';
import Paginação from "../../../comum/components/Paginação";
import { buscaFiltrarVazio, buscaSemResultado, filtrosVaziosContainer } from "../../../../utils/mensagens";
import FooterContent from '../../../comum/components/FooterContent';
import InputFiltro from '../../../comum/components/InputFiltro';
import { IconeCarregar } from '../../../comum/components/Icones';

import _ from 'lodash';
import Card from '../../../comum/components/Card';

@inject("store")
@DataWrapper
@observer
export class Triagem extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new TriagemStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Triagem Depot");

        this.appStore.showTopbar(true);

        let listar = false;

        if (this.controller.placaCavalo) {
            this.controller.adicionarFiltro("placaCavalo", this.controller.placaCavalo)
            listar = true;
        }
        if (this.controller.cnh) {
            this.controller.adicionarFiltro("cnh", this.controller.cnh)
            listar = true;
        }

        if (listar)
            this.controller.listar(this);
    }

    render() {
        let BuscaVaziaMsg

        if (this.controller.buscaVazia) {
            BuscaVaziaMsg = buscaSemResultado
        } else if (this.controller.buscaSemParametro) {
            BuscaVaziaMsg = filtrosVaziosContainer
        } else {
            BuscaVaziaMsg = ""
        }

        let exibirPaginacao = this.controller.numeroPaginas > 1;
        let Paginacao = exibirPaginacao ? <Paginação controller={this.controller} /> : "";

        return (
            <div>
                <div className="form-wrapper">
                    <Container fluid>
                        <Card>
                            <div className="filtros">
                                <Row className="align-items-end">

                                    <InputFiltro className="mb-1" titulo="Placa" xl={3} sm={6} xs={12}
                                        uppercase={true}
                                        onEnter={() => this.controller.listar()}
                                        onChange={e => this.controller.adicionarFiltro("placaCavalo", e.target.value)}
                                    />

                                    <InputFiltro className="mb-1" titulo="CNH" xl={3} sm={6} xs={12}
                                        uppercase={true}
                                        onEnter={() => this.controller.listar()}
                                        onChange={e => this.controller.adicionarFiltro("cnh", e.target.value)}
                                    />

                                    <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom">
                                        <Button onClick={(evento) => this.controller.listar(evento)} className="btn-com-bordas-primary btn-filtrar">Filtrar</Button>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Container>
                    <Container fluid>
                        {this.controller.loading ?
                            <IconeCarregar tamanho="2x" /> :
                            <React.Fragment>
                                <Row className="mt-4">
                                    {this.controller.filtrado
                                        ? this.controller.listarAgendamentos()
                                        :
                                        <Col xs={12}>
                                            <span className="mensagem-filtrar">
                                                {BuscaVaziaMsg === "" && buscaFiltrarVazio}
                                            </span>
                                        </Col>
                                    }
                                </Row>
                                <div className="mensagem-aviso">
                                    {BuscaVaziaMsg}
                                </div>
                                {Paginacao}
                            </React.Fragment>
                        }
                    </Container>
                </div>
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.total}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={(e) => this.controller.listar(e)}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>

                </Footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-triagem/tela/Triagem.js